import { useEffect, useRef } from 'react';

// Foreground transitions only, never on mount — a consumer wanting both calls its own mount effect.
export const useAppForeground = (onForeground: () => void) => {
  const callbackRef = useRef(onForeground);
  callbackRef.current = onForeground;

  useEffect(() => {
    const handleFocus = () => callbackRef.current();

    const handleVisibilityChange = () => {
      if (document.visibilityState !== 'visible') {
        return;
      }
      callbackRef.current();
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    window.addEventListener('focus', handleFocus);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      window.removeEventListener('focus', handleFocus);
    };
  }, []);
};
